export const HANGTEN_SIZES = ['24','25','26','27','28','29','30','31','32','34','36','38','XS','S','M','L','XL','XXL','2XL'];
export const PRETTYFIT_SIZES = ['35','36','37','38','39','40'];
export function normalizeShops(data) {
  const list = data.locations || data.rows;
  if (!Array.isArray(list)) throw new Error('Shop list is unavailable. Please refresh.');
  return list.map(row => ({code:String(row.code || '').trim().toUpperCase(), name:row.name || row.code,
    brand:String(row.brand || '').toUpperCase(), type:String(row.location_type || row.locationType || row.type || 'SHOP').toUpperCase(),
    active:row.is_active ?? row.isActive ?? true}))
    .filter(row => row.code && row.type === 'SHOP' && row.active !== false)
    .sort((a,b) => a.code.localeCompare(b.code));
}
export function mergeMatrix(rows) {
  const grouped = new Map();
  for (const row of rows) {
    const key = JSON.stringify([row.locationCode, row.productCode, row.color || '']);
    if (!grouped.has(key)) grouped.set(key, {key, locationCode:row.locationCode, productCode:row.productCode, color:row.color || '', sizes:{}, prices:[]});
    const item = grouped.get(key);
    for (const [rawSize, value] of Object.entries(row.sizes || {})) {
      const size = rawSize.trim().toUpperCase() || 'ONE SIZE';
      const qty = Number(value);
      if (Number.isFinite(qty)) item.sizes[size] = (item.sizes[size] || 0) + qty;
    }
    const price = Number(row.priceMmk);
    if (Number.isFinite(price) && price >= 0 && !item.prices.includes(price)) item.prices.push(price);
  }
  return [...grouped.values()].map(row => ({...row, totalQty:Object.values(row.sizes).reduce((sum,qty)=>sum+qty,0),prices:row.prices.sort((a,b)=>a-b)}))
    .sort((a,b)=>a.locationCode.localeCompare(b.locationCode)||a.productCode.localeCompare(b.productCode)||a.color.localeCompare(b.color));
}
export function matrixColumns(rows, brand) {
  const base = brand === 'PRETTYFIT' ? PRETTYFIT_SIZES : HANGTEN_SIZES;
  const extra = [...new Set(rows.flatMap(row=>Object.keys(row.sizes)))].filter(size=>!base.includes(size)).sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
  return [...base,...extra];
}
export function stockIssues(rows, mode, quantity='ALL') {
  return rows.flatMap(row=>Object.entries(row.sizes).filter(([,qty])=>mode === 'negative' ? qty<0 : qty>0 && qty<=3 && (quantity==='ALL'||qty===Number(quantity)))
    .map(([size,qty])=>({...row,key:row.key+':'+size,size,qty})));
}
